<template>
  <div class="payment-method">
    
    <app-loading v-if="loaded_pm != null && !hideCardVariants" :loading="loading_pm">
      <SidebarSwitcher
        v-model="card_variant" 
        :items="card_variants"
        @input="onInput"
      />
    </app-loading>

    <template v-if="card_variant !== 'default'">
      <app-text-input 
        :label="$ml.get('Cardholder name')" 
        v-model="pm.billing_details.name"
        @input="onInput"
      />
      <CardInput @input="onCardInput"/>
      <app-text-input
        :label="$ml.get('Billing address')" 
        v-model="pm.billing_details.address.line1"
        @input="onInput"
      />
      <SidebarSwitcher
        v-model="person_type" 
        :items="person_type_variants"
        @input="onPersonTypeSwitch"
      />
      
      <transition name="fade">
        <app-text-input
          :label="$ml.get('VAT number')" 
          v-if="person_type === 'company'" 
          v-model="pm.metadata.vat_number"
          @input="onInput"
        />
      </transition>
    </template>

  </div>
</template>

<script>
import SidebarSwitcher from '@/components/common/SidebarSwitcher';
import CardInput from '@/components/common/CardInput';
import { UserAPI } from '@/api';
export default {

  props: {
    hideCardVariants: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      person_type_variants: [
        {
          label: this.$ml.get('Private person'), 
          key: 'private'
        },
        {
          label: this.$ml.get('Company'), 
          key: 'company'
        }
      ],
      person_type: 'private',

      card_variants: [
        {
          label: this.$ml.get('Another'), 
          key: 'another'
        },
        {
          label: '', 
          key: 'default'
        }
      ],
      card_variant: 'another', // other | default

      pm: {
        type: 'card',
        card: null,
        billing_details: {
          email: this.$store.getters['user/data'].email,
          name: '',
          address: {
            line1: ''
          },
        },
        metadata: {
          vat_number: null,
        }
      },

      loading_pm: false,
      loaded_pm: {},
    }
  },

  methods: {
    onInput() {
      if(this.card_variant === 'default') {
        this.$emit('input', null);
      } else {
        this.$emit('input', this.pm);
      }
    },

    onCardInput(card) {
      this.pm.card = card;
      this.onInput();
    },

    onPersonTypeSwitch() {
      this.pm.metadata.vat_number = null;
      this.onInput();
    },

    loadPM() {
      this.loading_pm = true;
      UserAPI.getPaymentMethod().then(res => {
        this.loaded_pm = res.data.pm;

        if(!this.loaded_pm && !this.loaded_pm.pm && res.data.provider !== 'stripe') {
          return;
        }

        this.card_variants[1].label = '**** **** **** ' + this.loaded_pm.card.last4;
      }).finally(() => {
        this.loading_pm = false;
      });
    },
  },

  components: {
    SidebarSwitcher,
    CardInput,
  },

  mounted() {
    this.loadPM();
  }
}
</script>

<style lang="scss" scoped>

.payment-method {
  > * {
    margin-top: 30px;
  }

  .sidebar-switcher {
    padding: 10px 0 !important;
  }
}

</style>